var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArObject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H34V28C34 31.3137 31.3137 34 28 34H6C2.68629 34 0 31.3137 0 28V6Z",
    fill: "#FF5E8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6097 13.5928C10.1365 13.3404 10.1365 12.6621 10.6097 12.4097L16.6855 9.1695C16.8827 9.06434 17.1193 9.06435 17.3164 9.16952L23.3915 12.4097C23.8647 12.6621 23.8647 13.3404 23.3915 13.5928L17.3164 16.833C17.1193 16.9381 16.8827 16.9382 16.6855 16.833L10.6097 13.5928ZM9.83843 21.1941C9.62919 21.0749 9.5 20.8525 9.5 20.6117V15.155C9.5 14.6406 10.0555 14.3179 10.5024 14.5726L16.1656 17.8005C16.3749 17.9198 16.504 18.1421 16.504 18.383V23.8397C16.504 24.3541 15.9486 24.6768 15.5017 24.4221L9.83843 21.1941ZM23.4975 14.573C23.9444 14.3181 24.5 14.6409 24.5 15.1554V20.6118C24.5 20.8526 24.3709 21.0749 24.1617 21.1942L18.5025 24.4217C18.0556 24.6766 17.5 24.3538 17.5 23.8393V18.3829C17.5 18.1421 17.6291 17.9198 17.8383 17.8005L23.4975 14.573Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArObject);
export default __webpack_public_path__ + "static/media/ArObject.520cae8f97557c40c041c58ac07d9421.svg";
export { ForwardRef as ReactComponent };